import type { Activity } from "../api/assignments/Assignments.domain";
import type { Rule, Rules } from "../api/rules/Rules.domain";

export interface ValidationResult {
  valid: boolean;
  message?: string;
}

/**
 * Returns whether all activities are valid: each has type, return status,
 * and all required specific fields (from the matching rule) filled.
 */
export function validateActivitiesList(activities: Activity[], rules: Rules): ValidationResult {
  if (!activities?.length) {
    return { valid: true };
  }

  for (const act of activities) {
    if (!act.activityType?.code || !act.returnStatus) {
      return {
        valid: false,
        message: "Une activité doit avoir un type et un statut de retour",
      };
    }

    const rule = rules.rules.find((r: Rule) => r.activityTypeCode === act.activityType?.code);
    if (!rule) {
      return {
        valid: false,
        message: `Type d'activité non trouvé dans les règles: ${act.activityType?.code}`,
      };
    }

    const possibleReturn = rule.possibleReturns.find(
      (r) => r.stepCode === act.responseDetail?.stepCode,
    );
    const requiredFields = possibleReturn?.specificFields || [];
    const activityFields = act.responseDetail?.dynamicProperties || [];

    const missingField = requiredFields.find(
      (field) =>
        !activityFields.some(
          (prop) =>
            prop.key === field.code && typeof prop.value === "string" && prop.value.trim() !== "",
        ),
    );

    if (missingField) {
      return {
        valid: false,
        message: `Champ obligatoire manquant: ${missingField.label || missingField.code}`,
      };
    }
  }

  return { valid: true };
}
